export default __webpack_public_path__ + "static/1-226930c36c234c8d847c3662b505828c.png";